import { utils } from './-global.min.js'

const {
  formatPrice,
  one,
  all
} = utils

class HHProductsBundle extends HTMLElement {
  constructor() {
    super()

    this.$products = all('.bundle-item-wrapper', this)
    this.$confirmActions = all('.bundle-item__action', this)
    this.activeProduct = one('.bundle-item-wrapper__active', this)
    this.atc = one('.js-bundle-atc', this)
    this.startBundle = one('.js-bundle-start', this)
    this.bundleHeroGrid = one('.bundle-product-hero__grid', this)
    this.scrollOffset = 200

    this.clickProductPanel = this.clickProductPanel.bind(this)
    this.toggleProductPanel = this.toggleProductPanel.bind(this)
    this.calculateHeight = this.calculateHeight.bind(this)
    this.getNextBundleItem = this.getNextBundleItem.bind(this)
    this.changeMedia = this.changeMedia.bind(this)

    this.$discount = one('.js-product-panel').dataset.discount;
    
  }

  connectedCallback() {
    this.attachListeners()

    this.changePrice()
  }

  disconnectedCallback() {
    this.removeListeners()
  }

  clickProductPanel(item) {

    if (item.classList.contains('bundle-item-wrapper__active')) return

    if (this.activeProduct) {
      this.toggleProductPanel(this.activeProduct)
      this.calculateHeight(this.activeProduct)
      this.activeProduct = item
    }

    this.changeMedia(item)
    this.toggleProductPanel(item)
    this.calculateHeight(item)

    // window.scrollTo({
    //   top: item.offsetTop - this.scrollOffset,
    //   behavior: 'smooth'
    // })
  }

  toggleProductPanel(item) {
    const itemHero = one('.bundle-item-hero', item)
    item.classList.toggle('bundle-item-wrapper__active')
    itemHero.classList.toggle('bundle-item-hero__active')
    itemHero.classList.toggle('bundle-item-hero__closed')
  }

  calculateHeight(item) {
    item.style.height = ''
    item.style.height = `${item.scrollHeight}px`
  }

  changePrice() {
    let variant = null,
      price = 0,
      compare_at_price = 0
    this.$products.forEach((item) => {
      variant = JSON.parse(item.getAttribute('data-variant'))
      price += Number((variant.id == '20481231487074' || 
        variant.id == '39670940794978' || 
        variant.id == '20481231749218' || 
        variant.id == '20481231913058' || 
        variant.id == '30764227461218' || 
        variant.id == '30764230770786' || 
        variant.id == '30764229951586' || 
        variant.id == '41330282725474' || 
        variant.id == '41330282758242') ? variant.price * 2 : variant.price)
      compare_at_price += Number(variant.compareAtPrice)
    })
    console.log('my discount is ' + this.$discount);
    console.log('my compare at price is ' + price);
    const price_elem = one('.product-panel__price', this)

    // When the EXCLUSIVE30 code is active and this bundle is eligible (its price element
    // carries the precomputed exclusive30 attribute), price at 30% off instead of the
    // default bundle discount, so changing a variant keeps the discount the cart charges.
    let discount = parseFloat(this.$discount)
    if (
      price_elem &&
      price_elem.hasAttribute('data-exclusive30-price') &&
      typeof window.exclusive30IsActive === 'function' &&
      window.exclusive30IsActive()
    ) {
      discount = 0.30
    }

    if (compare_at_price && compare_at_price > price) {
      price_elem.innerHTML = `<del>${formatPrice(compare_at_price).replace('.00', '')}</del>` +
        `<ins>${formatPrice(price).replace('.00', '')}</ins>`
    } else if (discount) {
      price_elem.innerHTML = `<del>${formatPrice(price).replace('.00', '')}</del>` +
        `<ins>${formatPrice(price - (price * discount)).replace('.00', '')}</ins>`
    } else {
      price_elem.innerHTML = formatPrice(price).replace('.00', '')
    }
  }

  clickConfirm(event, item) {
    event.preventDefault()

    const bundleItem = item.closest('.bundle-item-wrapper')
    const bundleItemHero = one('.bundle-item-hero', bundleItem)
    const productPanelGrid = one('.product-panel__grid', bundleItem)
    const bundleItemOptions = all('.bundle-item-option', bundleItem)
    const variant = JSON.parse(bundleItem.getAttribute('data-variant'))
    const options = bundleItem.getAttribute('data-options').split(',')

    bundleItem.setAttribute('data-variant-id', variant.id)
    bundleItemHero.classList.add('bundle-item-hero__sel')

    bundleItemOptions.forEach(opt => opt.remove())

    let child = null,
      index = ''
    options.forEach((opt, i) => {
      index = `option${i + 1}`
      child = document.createElement('p')
      child.className = 'bundle-item-option'
      child.innerHTML = `${opt}: ${variant[index]}`
      productPanelGrid.appendChild(child)
    })

    setTimeout(() => {
      bundleItem.classList.remove('bundle-item-wrapper__active')
      bundleItemHero.classList.remove('bundle-item-hero__active')
      bundleItemHero.classList.add('bundle-item-hero__closed')

      this.calculateHeight(bundleItem)
    }, 100)

    this.activeProduct = null

    const nextItem = this.getNextBundleItem()
    if (nextItem) {
      this.toggleProductPanel(nextItem)
      this.calculateHeight(nextItem)
      this.activeProduct = nextItem
      // window.scrollTo({
      //   top: nextItem.offsetTop - this.scrollOffset,
      //   behavior: 'smooth'
      // })
// Assuming the first product is the "current item"
const currentItem = nextItem;
if (currentItem) {
  const variantWrapper = currentItem.querySelector('hh-product-variant');
  let options = variantWrapper.variantData;

  // Assuming this.currentVariant.id is already defined with the ID you're looking for
let matchingOptionId = parseInt(variantWrapper.dataset.variantId);
let matchingOption = options.find(option => option.id === matchingOptionId);
setTimeout(function() {
var mySlider = $('.bundle-item-hero__active').find('.js-product-media-slider').eq(0);
var myOtherMedia = $('.bundle-item-hero__active').find('.other_media').eq(0);

  const data = {
    product_id: variantWrapper.dataset.section,
    parent_id: variantWrapper.dataset.parentProduct,
    variant_id: variantWrapper.dataset.variantId,
    product_url: variantWrapper.dataset.url,
    is_bundle: true,
    variant_details: matchingOption,
    this_slider: mySlider,
    other_media: myOtherMedia
  };
  document.dispatchEvent(
    new CustomEvent('product-media::change', { bubbles: true, detail: data })
  )
},150);
}
      setTimeout(() => {
      this.atc.setAttribute('disabled', true);
      if ($('.bundle-item-hero__active').find('.option-already-selected').length > 0) {
        console.log('already selected so doing nothing');
      }
      else {
      $('.bundle-item-hero__active button[data-value="Queen"]').click();
      $('.bundle-item-hero__active button[data-value="Full/Queen"]').click();
      }
      },100);
    }
     else {
      this.atc.removeAttribute('disabled')
    }
  }

  getNextBundleItem() {
    return this.$products.filter(item => !item.getAttribute('data-variant-id'))[0] || null
  }

  changeMedia(item) {
    const variantWrapper = item.querySelector('hh-product-variant');
    let options = variantWrapper.variantData;
    // Assuming this.currentVariant.id is already defined with the ID you're looking for
let matchingOptionId = parseInt(variantWrapper.dataset.variantId);
// Using .find() to find the matching option
let matchingOption = options.find(option => option.id === matchingOptionId);
var mySlider = $('.bundle-item-hero__active').find('.js-product-media-slider').eq(0);
var myOtherMedia = $('.bundle-item-hero__active').find('.other_media').eq(0);
    const data = {
      product_id: variantWrapper.dataset.section,
      parent_id: variantWrapper.dataset.parentProduct,
      variant_id: variantWrapper.dataset.variantId,
      product_url: variantWrapper.dataset.url,
      is_bundle: true,
      variant_details: matchingOption,
      this_slider: mySlider,
      other_media: myOtherMedia
    }
  }

  doStartBundle(event) {
    this.bundleHeroGrid.classList.remove('bundle-product-hero__init__grid')
    this.startBundle.classList.add('hidden')

    this.$products.forEach((item) => {
      this.calculateHeight(item)
    })
  // Assuming the first product is the "current item"
  const currentItem = this.$products[0];
  if (currentItem) {
    const variantWrapper = currentItem.querySelector('hh-product-variant');
    let options = variantWrapper.variantData;
  
    // Assuming this.currentVariant.id is already defined with the ID you're looking for
  let matchingOptionId = parseInt(variantWrapper.dataset.variantId);
  // Using .find() to find the matching option
  let matchingOption = options.find(option => option.id === matchingOptionId);
  var mySlider = $('.bundle-item-hero__active').find('.js-product-media-slider').eq(0);
  var myOtherMedia = $('.bundle-item-hero__active').find('.other_media').eq(0);
    const data = {
      product_id: variantWrapper.dataset.section,
      parent_id: variantWrapper.dataset.parentProduct,
      variant_id: variantWrapper.dataset.variantId,
      product_url: variantWrapper.dataset.url,
      is_bundle: true,
      variant_details: matchingOption,
      this_slider: mySlider,
      other_media: myOtherMedia
    };
    document.dispatchEvent(
      new CustomEvent('product-media::change', { bubbles: true, detail: data })
    )
  }
  
  if ($('.bundle-item-hero__active').find('.option-already-selected').length > 0) {
    // option already selected so we do nothing now
  }
  else {
  $('.bundle-item-hero__active button[data-value="Queen"]').click();
  $('.bundle-item-hero__active button[data-value="Full/Queen"]').click();
  }
  }

  attachListeners() {
    this.$products.forEach((item) => {
      item.addEventListener('click', (event) => {
        this.clickProductPanel(item)
      }, false)
    })

    this.$confirmActions.forEach((item) => {
      item.addEventListener('click', (event) => {
        this.clickConfirm(event, item)
      }, false)
    })

    this.startBundle.addEventListener('click', this.doStartBundle.bind(this))

    document.addEventListener('bundle-price::change', (event) => this.changePrice())
  }

  removeListeners() {
    this.$products.forEach((item) => {
      item.removeEventListener('click', (event) => {
        this.clickProductPanel(item)
      }, false)
    })

    this.$confirmActions.forEach((item) => {
      item.removeEventListener('click', (event) => {
        this.clickConfirm(event, item)
      }, false)
    })

    this.startBundle.removeEventListener('click', this.doStartBundle.bind(this))
  }
}

customElements.define('hh-products-bundle', HHProductsBundle)
